export const PALETTES = {
  midnight: {
    name: 'Meadow',
    bg: 'oklch(0.08 0.015 150)',
    horizon: 'oklch(0.02 0.005 150 / 0.95)',
    horizonMid: 'oklch(0.04 0.008 150 / 0.55)',
    vignette: 'oklch(0.02 0.005 150 / 0.6)',
    handTint: 'oklch(0.85 0.13 140 / 0.12)',
    shades: [
      'oklch(0.68 0.16 140)', 'oklch(0.55 0.15 143)',
      'oklch(0.42 0.13 145)', 'oklch(0.30 0.10 148)', 'oklch(0.20 0.07 150)',
    ],
    spine: 'oklch(0.85 0.14 135)',
  },
  ember: {
    name: 'Ember',
    bg: 'oklch(0.10 0.022 30)',
    horizon: 'oklch(0.02 0.008 28 / 0.95)',
    horizonMid: 'oklch(0.04 0.01 28 / 0.55)',
    vignette: 'oklch(0.02 0.01 25 / 0.6)',
    handTint: 'oklch(0.82 0.16 60 / 0.15)',
    shades: [
      'oklch(0.65 0.15 60)', 'oklch(0.52 0.14 50)',
      'oklch(0.40 0.12 42)', 'oklch(0.28 0.09 35)', 'oklch(0.18 0.06 30)',
    ],
    spine: 'oklch(0.85 0.15 60)',
  },
  abyss: {
    name: 'Tide',
    bg: 'oklch(0.08 0.022 265)',
    horizon: 'oklch(0.02 0.008 270 / 0.95)',
    horizonMid: 'oklch(0.04 0.01 270 / 0.55)',
    vignette: 'oklch(0.01 0.005 270 / 0.6)',
    handTint: 'oklch(0.78 0.14 210 / 0.15)',
    shades: [
      'oklch(0.62 0.13 215)', 'oklch(0.50 0.12 225)',
      'oklch(0.38 0.11 240)', 'oklch(0.26 0.09 255)', 'oklch(0.18 0.07 265)',
    ],
    spine: 'oklch(0.82 0.12 210)',
  },
}
